import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface IMembershipExcelDto {
  membershipId: string;
  password: string;
  projects: string;
  createdAt: string;
}

export interface IMembershipRequestDto {
  membershipId: string;
  password: string;
  projects: ('HIGHLIGHT' | 'ADLIGHT' | 'TTS' | 'D2X' | 'VIEWX' | 'BLIB')[];
  createdAt: string;
}

export interface IMembershipLoginDto {
  membershipId: string;
  password: string;
}

export class User {
  private host = window.location.hostname;
  private readonly apiUrl = `${environment.nestjsUrl}/membership`;

  constructor(private readonly http: HttpClient) { }

  save(data: IMembershipRequestDto): Observable<any> {
    const url = `${this.apiUrl}`;

    const headers = new HttpHeaders({
      'accept': 'application/json',
    });

    const body = {
      membershipId: data.membershipId,
      password: data.password,
      projects: data.projects,
      createdAt: data.createdAt
    };

    return this.http.post(url, body, { headers });
  }

  get(id: number) {
    const url = `${this.apiUrl}/${id}`;

    return this.http.get(url);
  }

  login(data: IMembershipLoginDto) {
    const url = `${this.apiUrl}/login`;

    const headers = new HttpHeaders({
      'accept': 'application/json',
    });

    const body = {
      membershipId: data.membershipId,
      password: data.password,
    };

    return this.http.post(url, body, { headers });
  }

}